
import { Heading1Icon } from "lucide-react";

import { prop, define, useCraftProp, variant } from "@/components/builder/utils";

import ContentEditable from "../utils/ContentEditable";
import { useTailwindConfig } from "../utils/tailwindConfig/hooks";

import BasePreview from "./base";

function HeadingPreview({ properties: { tagName = 'h1', ...properties }, ...props }) {
  const { value, setValue } = useCraftProp('content')

  return <BasePreview properties={properties} {...props}>
    <ContentEditable
      html={value}
      onChange={setValue}
      tagName={tagName}
    />
  </BasePreview>
}

function VariantPreview({ content, variant }) {
  const { value: { [variant]: className } } = useTailwindConfig('base')

  return <div className={`${className} leading-tight truncate text-gray-900 dark:text-gray-100`} dangerouslySetInnerHTML={{ __html: content }} />
}

export default define('heading', HeadingPreview)
  .tag({ children: 'content', propTagName: 'tagName' })
  .palete(<Heading1Icon size={16} />, 'Heading', 'Content')
  .property(prop.stylePattern())
  .property(prop.predefined.customClass())
  .property(prop.predefined.textContent())
  .property(prop.new('Variant', 'variant').hide().own())
  .property(prop.select('Heading', 'tagName').category('default').ignoreDevice().own()
    .blockClear()
    .options(prop.options()
      .add('Heading 1', 'h1')
      .add('Heading 2', 'h2')
      .add('Heading 3', 'h3')
      .add('Heading 4', 'h4')
      .add('Heading 5', 'h5')
      .add('Heading 6', 'h6')))
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.borders())
  .property(prop.predefined.textColor())
  .property(prop.predefined.align())
  .property(prop.predefined.letterSpacing())
  .property(prop.predefined.lineHeight())
  .property(prop.predefined.fontSize())
  .property(prop.predefined.fontWeight())
  .property(prop.predefined.fontFamily())
  .property(prop.predefined.fontDecoration())
  .property(prop.predefined.textShadow())
  .property(prop.predefined.attributes())
  .variant(variant(VariantPreview, null, 'Heading level')
    .add('h1', 'Heading 1', { content: 'Heading 1', tagName: 'h1' }, { badge: 'H1', hint: '60px' })
    .add('h2', 'Heading 2', { content: 'Heading 2', tagName: 'h2' }, { badge: 'H2', hint: '48px' })
    .add('h3', 'Heading 3', { content: 'Heading 3', tagName: 'h3' }, { badge: 'H3', hint: '36px' })
    .add('h4', 'Heading 4', { content: 'Heading 4', tagName: 'h4' }, { badge: 'H4', hint: '30px' })
    .add('h5', 'Heading 5', { content: 'Heading 5', tagName: 'h5' }, { badge: 'H5', hint: '24px' })
    .add('h6', 'Heading 6', { content: 'Heading 6', tagName: 'h6' }, { badge: 'H6', hint: '20px' }))
  .defaultProps({})
  .ignoreResetProps(['content', 'tagName', 'variant'])
  .build()
